import { Badge, Text } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { countryCodeToName } from "@oysterhr/common"
import { EquityTypeEnum } from "@oysterhr/schema"
import { useKnowledgeBaseMessage } from "../../pages/CompanyEquityGrantFormPage/KnowledgeBaseMessage/useKnowledgeBaseMessage"

interface EquityHiringAdvisorProps {
  countryCode: string
}

export const EquityHiringAdvisor = ({ countryCode }: EquityHiringAdvisorProps) => {
  const { t } = useTranslation("equity/EquityGrantPage")
  const country = countryCodeToName(countryCode)
  const { loading, results } = useKnowledgeBaseMessage(countryCode, "SOP")
  const countrySupported = loading ? false : results[0]?.supported

  return (
    <div className="mb-8 flex flex-col gap-y-5" data-testid="equity-hiring-advisor">
      <Text size="medium" className="font-semibold">
        {t("equity", { country })}
      </Text>
      <div className="flex flex-col gap-y-5">
        {Object.values(EquityTypeEnum)
          .map(type => {
            const supported = countrySupported || type === EquityTypeEnum.Csh
            return (
              <div className="flex flex-col gap-y-2" key={type}>
                <div className="flex flex-row gap-x-4">
                  <Text size="small" className="font-semibold">
                    {t(type, { ns: "equity/EquityType" })}
                  </Text>
                  <Badge variation={supported ? "success" : "error"} size="sm">
                    {supported ? t("supported") : t("notSupported")}
                  </Badge>
                </div>
                <Text size="tiny" className="text-gray-400">
                  {t(`${type}.hiringAdvisor`)}
                </Text>
              </div>
            )
          })
          .reverse()}
      </div>
    </div>
  )
}
